import React from 'react';
import { IconButtonStyled } from './common/IconButtonStyled';
import { IconStyled } from './common/IconStyled';

interface Props {
  isFullscreen: boolean;
  onClick(): void;
}

const FullscreenButton: React.FC<Props> = ({ isFullscreen, onClick }) => {
  return (
    <IconButtonStyled title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'} onClick={onClick}>
      <IconStyled icon={isFullscreen ? 'fullscreen_exit' : 'fullscreen'} />
    </IconButtonStyled>
  );
};

export default FullscreenButton;
